// What the website's signup link asked for (captured in main.tsx): the plan
// for the first store and whether the person signs up as a partner.
export type SignupIntent = { plan: string; type: string };

const key = "sooquna.signup";

export function signupIntent(): SignupIntent {
  try {
    const raw = sessionStorage.getItem(key);
    if (raw) {
      const v = JSON.parse(raw) as Partial<SignupIntent>;
      return { plan: typeof v.plan === "string" ? v.plan : "", type: typeof v.type === "string" ? v.type : "" };
    }
  } catch { /* unavailable */ }
  return { plan: "", type: "" };
}

// forgetSignupPlan: the plan was used (or isn't on sale any more).
export function forgetSignupPlan() {
  try {
    const v = signupIntent();
    sessionStorage.setItem(key, JSON.stringify({ ...v, plan: "" }));
  } catch { /* unavailable */ }
}
